import { useAppContext } from '@/context';
import { logout, updateUserInStorage } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAuth, useAuthToken } from './useAuth';
import { useMutation } from './useMutation';

interface UseOtpVerifyProps {
  onSuccess: (res: ResponseObject | Api.UserObject) => void;
  onError?: TypeAny;
  otp: string;
}

export function useOtpVerify({ onSuccess, onError, otp }: UseOtpVerifyProps) {
  const { authData, setAuthData } = useAuth();
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const {
    isLoading,
    data = {},
    mutate,
    error
  } = useMutation({
    mutationKey: 'otp-verify',
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/user/verify/phone`,
        body: {
          otp
        },
        token
      }).then((response: Api.User | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
          return {};
        }

        // Extract user object from response (Api.User has a 'user' property)
        const userObject = 'user' in response ? response.user : (response as Api.UserObject);
        updateUserInStorage(userObject);
        setAuthData({ ...authData, user: userObject });

        return response;
      }),
    onSuccess,
    onError
  });

  return {
    isLoading,
    mutate,
    error,
    data
  };
}
